import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch, RootState } from '../store'

const ALL_PROJECTS_EXPORT_REQUEST = 'ALL_PROJECTS_EXPORT_REQUEST'
const ALL_PROJECTS_EXPORT_SUCCESS = 'ALL_PROJECTS_EXPORT_SUCCESS'
const ALL_PROJECTS_EXPORT_ERROR = 'ALL_PROJECTS_EXPORT_ERROR'
export const ALL_PROJECTS_EXPORT_RESET = 'ALL_PROJECTS_EXPORT_RESET'

interface AllProjectsExportRequestAction {
  type: typeof ALL_PROJECTS_EXPORT_REQUEST
}

interface AllProjectsExportSuccessAction {
  type: typeof ALL_PROJECTS_EXPORT_SUCCESS
  payload: Project[]
}

interface AllProjectsExportErrorAction {
  type: typeof ALL_PROJECTS_EXPORT_ERROR
  payload: string
}

type AllProjectsExportActionTypes =
  | AllProjectsExportRequestAction
  | AllProjectsExportSuccessAction
  | AllProjectsExportErrorAction

export const getAllProjectsExport =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch({
        type: ALL_PROJECTS_EXPORT_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const token = (userInfo as User).token

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

      const { data } = await axios.get(`/api/projects/export`, config)

      return dispatch({
        type: ALL_PROJECTS_EXPORT_SUCCESS,
        payload: data,
      })
    } catch (err) {
      const error = err as AxiosError

      return dispatch({
        type: ALL_PROJECTS_EXPORT_ERROR,
        payload: error.message,
      })
    }
  }

interface InitialState {
  data: Project[] | undefined
  error: string
  loading: boolean
  success: boolean
}

const initialState: InitialState = {
  data: undefined,
  error: '',
  loading: false,
  success: false,
}

export const allProjectsExportReducer = (
  state = initialState,
  action: ActionWithPayload<AllProjectsExportActionTypes>
) => {
  switch (action.type) {
    case ALL_PROJECTS_EXPORT_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      }
    case ALL_PROJECTS_EXPORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: '',
        success: true,
        loading: false,
      }
    case ALL_PROJECTS_EXPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case ALL_PROJECTS_EXPORT_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
